import * as React from 'react';
import { memo } from 'react';

export type BarPropsType = {
	children?: React.ReactNode;
};

export const Bar = ({ children }: BarPropsType) => <div className="m-bar">{children}</div>;

export default memo(Bar, (prevProps, nextProps) => {
	return prevProps.children === nextProps.children;
});
